<template>
  <div>
    <SearchHeader
      :queryInfo="queryInfo"
      :options1="options1"
      :flatpickrConfig="flatpickrConfig"
      @search="onSearch"
    />

  <div style="margin-right: 10px">
            活動開始日期：<br />
            <flat-pickr
              v-model="queryInfo.sActiveTime"
               :config="{ ...flatpickrConfig }"
              ref="flatpickrInstance"
            ></flat-pickr>
          </div>
   <div>
            活動結束日期：<br />
            <flat-pickr
              v-model="queryInfo.eActiveTime"
              :config="{ ...flatpickrConfig }"
              ref="endPicker"
            ></flat-pickr>
          </div>
    <SessionTable
      v-if="PrintSessionShow"
      :list="inputData2"
      @viewDetail="getALLActiveList2"
    />
  </div>
</template>

<script>
import SearchHeader from "@/components/SearchHeader.vue";
import SessionTable from "@/components/SessionTable.vue";
import * as tools from "../tool";

export default {
  components: { SearchHeader, SessionTable },

  data() {
    return {
      queryShow: false,
      PrintSessionShow: false,
      inputData2: [],
      queryInfo: {
        sActiveTime: "2025-01-01",
        eActiveTime: "2025-01-01",
        options1Value: 1,
        dptcd: "",
      },

      options1: [{ value: 1, text: "全系" }],

      flatpickrConfig: {
        allowInput: true,
        enableTime: false,
        defaultDate: "2025-01-01", // 清除當前選擇的日期
        weekNumbers: true,
        dateFormat: "YYYY-MM-DD",
        time_24hr: false,
        locale: {
          weekdays: {
            shorthand: ["日", "一", "二", "三", "四", "五", "六"],
            longhand: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
          },
        },
      },
    };
  },

  methods: {
    onSearch(q) {
      this.queryInfo = q;
      this.queryShow = true;
      this.PrintSessionShow = true;

      this.$http
        .put("./WebApi/HighSchoolEnrolling/GetALLSessionList2/", this.queryInfo)
        .then((res) => {
          this.inputData2 = res.data;
        });
    },

     getALLSessionList2() {
      let vm = this;
      vm.queryShow=true ;
      vm.currentPage = vm.queryInfo.options1Value - 1;
      vm.PrintSessionShow =true ;

      vm.getActiveTime();
      this.$http
        .put("./WebApi/HighSchoolEnrolling/GetALLSessionList2/", vm.queryInfo)
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData2 = response.data;
            vm.total2= vm.inputData2.length;
            console.log(vm.inputData2);
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },

    getALLActiveList2(aid,updateUser) {
     this.queryInfo.updateUser = updateUser;
      let vm = this;
      vm.currentPage = vm.queryInfo.options1Value - 1;
      vm.PrintSessionShow = false ;
      vm.queryInfo.aid = aid;
    // vm.queryInfo.updateUser = updateUser;
     // vm.getActiveTime();
      this.$http
        .put("./WebApi/HighSchoolEnrolling/GetALLActiveList2/", vm.queryInfo)
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData2 = response.data;
            vm.total2 = vm.inputData2.length;
            console.log(vm.inputData2);
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
  },
};
</script>
